
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useActivation, ActivationKey } from '@/contexts/ActivationContext';

interface SidebarItem {
  label: string;
  href: string;
  icon: string;
  activationKey?: ActivationKey;
}

const sidebarItems: SidebarItem[] = [
  { label: 'Resumen de Activación', href: '/configuraciones/resumen', icon: 'dashboard' },
  { label: 'Conexión SII', href: '/configuraciones/conexion-sii', icon: 'receipt_long', activationKey: 'conexionSii' },
  { label: 'Credenciales Adquirente', href: '/configuraciones/credenciales-adquirente', icon: 'key', activationKey: 'credencialesAdquirente' },
  { label: 'Pago automático de cuentas (PAC)', href: '/configuraciones/pago-automatico-cuentas', icon: 'account_balance', activationKey: 'scrapeCuentas' },
  { label: 'Pago automático con tarjeta (PAT)', href: '/configuraciones/pago-automatico-tarjetas', icon: 'credit_card', activationKey: 'lupsActivation' },
  { label: 'Firma de Pagaré', href: '/configuraciones/firma-pagare', icon: 'gavel', activationKey: 'firmaPagare' },
  { label: 'Cuenta Bancaria', href: '/configuraciones/cuenta-bancaria', icon: 'account_balance', activationKey: 'cuentaBancaria' },
  { label: 'Términos y Condiciones', href: '/configuraciones/terminos', icon: 'description', activationKey: 'terminos' },
];

export default function SettingsSidebar() {
  const pathname = useLocation().pathname;
  const { isStepComplete, isLoading } = useActivation();

  return (
    <aside className="w-full md:w-80 flex-shrink-0">
      <nav className="flex flex-col space-y-1">
        <h3 className="px-3 text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">
          Configuración de Cuenta
        </h3>
        {sidebarItems.map((item) => {
          const isActive = pathname === item.href || pathname === item.href + '/';
          const isPending =
            !isLoading && item.activationKey !== undefined && !isStepComplete(item.activationKey);
          const isCompleted =
            !isLoading && item.activationKey !== undefined && isStepComplete(item.activationKey);
          return (
            <Link
              key={item.href}
              to={item.href}
              className={
                isActive
                  ? 'relative bg-primary/10 text-primary font-bold group flex items-center px-3 py-2 text-sm rounded-md border-l-4 border-transparent'
                  : 'relative text-slate-600 hover:bg-slate-50 hover:text-slate-900 group flex items-center px-3 py-2 text-sm font-medium rounded-md border-l-4 border-transparent dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white'
              }
            >
              <span
                className={`material-symbols-outlined mr-3 text-lg ${
                  isActive ? '' : 'text-slate-400 group-hover:text-slate-500'
                }`}
              >
                {item.icon}
              </span>
              <span className="truncate pr-5">{item.label}</span>
              {isPending && (
                <span className="absolute right-2 top-2 w-2 h-2 rounded-full bg-red-500" />
              )}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
